<template>
  <fragment>
    <page-nav />
  </fragment>
</template>

<script>
import PageNav from '../PageNav'

export default {
  components: {
    PageNav
  }
}
</script>
